import { all } from "redux-saga/effects";

import Auth from "./Auth";
import GoogleAuth from "./GoogleAuth";
import AccountDefault from "./AccountDefault";
import Account from "./Accounts";
import AdminDefault from "./AdminDefault";
import LoginHistory from "./LoginHistory";
// reports
import EmotionDefinitions from "./EmotionDefinitions";
import Moods from "./Moods";
import Personality from "./Personality";
import Culture from "./Culture";
import Leadership from "./Leadership";
import EmployeeReport from "./EmployeeReport";
import Ambassador from "./Ambassadors";
import EmployeeCategory from "./EmployeeCategory";
import EmployeePermission from "./EmployeePermission";
import IndustryBenchmark from "./IndustryBenchmark";
import ChatGpt from "./ChatGpt";
// forms
import Departments from "./Departments";
import Organization from "./Organization";
import Employee from "./Employee";
import EmployeeRole from "./EmployeeRole";
import EmployeeLog from "./EmployeeLog";
import EmployeeRecord from "./EmployeeRecord";
import EmployeeRecordList from "./EmployeeRecordList";
import EmployeeRecordValue from "./EmployeeRecordValue";
import Payment from "./Payment";

import Teams from "./Teams";
import TeamType from "./TeamType";
import TeamAccess from "./TeamAccess";
// questions
import SurveyQuestion from "./SurveyQuestions";
// de brief
import DebriefSchedule from "./DebriefSchedule";
import DebriefSummary from "./DebriefSummary";
import DebriefResponse from "./DebriefResponse";
import DebriefToken from "./DebriefToken";
import DebriefAnalytics from "./DebriefAnalytics";
import DebriefPdfReport from "./DebriefPdfReport";
import PresentationReport from "./PresentationReport";
// gpt
import GptSummary from "./GptSummary";
import GptMembers from "./GptMembers";
import GptModelMain from "./GptModelMain";
import GptResponseMain from "./GptResponseMain";
import GptResponseScore from "./GptResponseScore";
import GptWebChat from "./GptWebchat";
import GptRecommendation from "./GptRecommendation";
import GptRecommendationLog from "./GptRecommendationLog";
import GptWebChatProcess from "./GptWebchatProcess";
import ReportTemplate from "./ReportTemplate";
import RecommendationModelRating from "./RecommendationModelRating";
import RecommendationModels from "./RecommendationModels";
import ScheduleTemplate from "./ScheduleTemplate";
import SurveyAiLog from "./SurveyAiLog";
import TaskTemplate from "./TaskTemplate";
import TaskTemplateUserTask from "./TaskTemplateUserTask";
import TaskTemplateUserResponse from "./TaskTemplateUserResponse";
import TaskTemplateUserRequest from "./TaskTemplateUserRequest";
import ReportMicroservice from "./ReportMicroService";
import PredictiveModel from "./PredictiveModel";
//
import slackTasksSaga from './slackTasksSaga';
//
import Product from "./Product";
import ProductGroup from "./ProductGroup";
import ProductPrice from "./ProductPrice";
import ProductPackage from "./ProductPackage";
import ProdOrgContract from "./ProdOrgContract";
import ProdDevDoc from "./ProdDevDoc";
//
import Blog from "./Blog";
import BlogCategory from "./BlogCategory";
import BlogTag from "./BlogTag";
import WebImage from "./WebImage";
// marketing
import MarketingRoi from "./MarketingRoi";
// settings
import AppServer from "./AppServer";
import AppServerLog from "./AppServerLog";
import Documentation from "./Documentation";
import SurveyStandard from "./SurveyStandard";
import ActivityLog from "./ActivityLog";
import ChangeLog from "./ChangeLog";
import FileUpload from "./FileUpload";
import EmailTemplate from "./EmailTemplate";
import PdfTemplate from "./PdfTemplate";
import SurveyStructure from "./SurveyStructure";
import SurveyStructureCompliance from "./SurveyStructureCompliance";
import SurveyToken from "./SurveyToken";
import SignUpToken from "./SignUpToken";
import SurveyResponses from "./SurveyResponses";
import GlobalSchedule from "./GlobalSchedule";
import SurveyScheduleFrequency from "./SurveyScheduleFrequency";
import TeamInSchedule from "./TeamInSchedule";
import LeadersInSchedule from "./LeadersInSchedule";
import LeadersSurveyParticipants from "./LeadersSurveyParticipants";
import SurveyCompliance from "./SurveyCompliance";
import PersonalityTeams from "./PersonalityTeams";
import PersonalityParticipants from "./PersonalityParticipants";
import ValidateEmail from "./ValidateEmail";
import OnBoarding from "./OnBoarding";
import EmailDeliveryStatus from "./EmailDeliveryStatus";
import Subscription from "./Subscription";
import AppListUrl from "./AppListUrl";
import WebHookCredential from "./WebApiCredential";
import WebHookLog from "./WebApiLog";
// v3 apps
import TagTypes from "./TagTypes";
import ReportDimension from "./ReportDimensions";
import QuestionBank from "./QuestionBanks";
import OrganizationCategoryTag from "./OrganizationCategoryTags";
import EmployeeCategoryTag from "./EmployeeCategoryTags";
import SurveyTemplateQuestion from "./SurveyTemplateQuestions";
import SurveyTemplateQuestionItem from "./SurveyTemplateQuestionItems";
import SurveyScheduler from "./SurveySchedulers";
import SurveyEvent from "./SurveyEvents";
import SurveyInvite from "./SurveyInvites";
import SurveyEventResponse from "./SurveyEventResponses";
import groupsSaga from "./Groups";
import ActionActions from "./ActionActions";
import ActionDashboard from "./ActionDashboard";
import ActionEvents from "./ActionEvents";
import ActionCampaign from "./ActionCampaign";
import ActionReport from "./ActionReport";
import ActionUpdate from "./ActionUpdate";
import ActionEmail from "./ActionEmail";
import ActionAnalytics from "./ActionAnalytics";
import ActionAssignee from "./ActionAssignee";
import ActionPhaseTransition from "./ActionPhaseTransition";
import ActionReminders from "./ActionReminders";
import ActionTemplate from "./ActionTemplate";
import ActionPlanningStatus from "./ActionPlanningStatus";
// import SurveySettings from "./SurveySettings";
import LLMLogSaga from "./LLmLog";
import PublicUpload from "./PublicUpload";
import StaffReports from './StaffReports';
// list
import SurveySettingList from "./SurveySettingList";

export function* rootSaga() {
  yield all([
    Auth(),
    GoogleAuth(),
    AccountDefault(),
    LoginHistory(),
    Account(),
    AppServer(),
    AppServerLog(),
    AdminDefault(),
    ActivityLog(),
    ActionActions(),
    ActionDashboard(),
    ActionEvents(),
    ActionCampaign(),
    ActionReport(),
    ActionUpdate(),
    ActionEmail(),
    ActionAnalytics(),
    ActionAssignee(),
    ActionPhaseTransition(),
    ActionReminders(),
    ActionTemplate(),
    ActionPlanningStatus(),
    ChangeLog(),
    EmotionDefinitions(),
    Moods(),
    Personality(),
    Culture(),
    Leadership(),
    Departments(),
    SurveyQuestion(),
    Organization(),
    Ambassador(),
    EmployeeReport(),
    IndustryBenchmark(),
    MarketingRoi(),
    ChatGpt(),
    Employee(),
    EmployeeRole(),
    EmployeeLog(),
    EmployeeRecord(),
    EmployeeRecordList(),
    EmployeeRecordValue(),
    EmployeeCategory(),
    EmployeePermission(),
    PresentationReport(),
    LLMLogSaga(),
    Blog(),
    BlogCategory(),
    BlogTag(),
    WebImage(),
    Payment(),
    Teams(),
    TagTypes(),
    ReportDimension(),
    QuestionBank(),
    OrganizationCategoryTag(),
    EmployeeCategoryTag(),
    SurveyTemplateQuestion(),
    SurveyTemplateQuestionItem(),
    SurveyScheduler(),
    SurveyEvent(),
    SurveyInvite(),
    SurveyEventResponse(),
    slackTasksSaga(),
    DebriefSchedule(),
    DebriefSummary(),
    DebriefResponse(),
    DebriefPdfReport(),
    DebriefToken(),
    DebriefAnalytics(),
    PredictiveModel(),
    GptSummary(),
    GptMembers(),
    GptModelMain(),
    GptResponseMain(),
    GptResponseScore(),
    GptWebChat(),
    GptWebChatProcess(),
    GptRecommendation(),
    GptRecommendationLog(),
    RecommendationModelRating(),
    Product(),
    ProductGroup(),
    ProductPrice(),
    ProductPackage(),
    ProdOrgContract(),
    ProdDevDoc(),
    ScheduleTemplate(),
    ReportTemplate(),
    RecommendationModels(),
    TeamAccess(),
    EmailTemplate(),
    PdfTemplate(),
    FileUpload(),
    SurveyStructure(),
    SurveyStructureCompliance(),
    TeamType(),
    SurveyToken(),
    SignUpToken(),
    SurveyAiLog(),
    TaskTemplate(),
    TaskTemplateUserTask(),
    TaskTemplateUserResponse(),
    TaskTemplateUserRequest(),
    ReportMicroservice(),
    SurveyResponses(),
    SurveyCompliance(),
    SurveyStandard(),
    GlobalSchedule(),
    SurveyScheduleFrequency(),
    TeamInSchedule(),
    LeadersInSchedule(),
    LeadersSurveyParticipants(),
    PersonalityTeams(),
    PersonalityParticipants(),
    ValidateEmail(),
    OnBoarding(),
    EmailDeliveryStatus(),
    Subscription(),
    SurveySettingList(),
    AppListUrl(),
    WebHookCredential(),
    WebHookLog(),
    StaffReports(),
    Documentation(),
    groupsSaga(),
    PublicUpload(),
  ]);
}

export default rootSaga;
